import { RoleMe } from '@/types/roles'
import { api } from '@/utils/api'
import { apiRolesMe } from '@/utils/api/url'
import { useQuery } from '@tanstack/react-query'

export const QUERY_KEY_ROLE_ME = 'QUERY_KEY_ROLE_ME'
export const useRoleMe = () => {
  const res = useQuery({
    queryKey: [QUERY_KEY_ROLE_ME],
    queryFn: () => api.get(apiRolesMe).then(({ data }) => data as RoleMe[]),
  })
  return res
}
